import slice from './dashboardInstanceSlice';

export * from './types';

export const {
  dashboardInstancePopulate,
  dashboardInstanceUpdatePath,
  dashboardInstanceToggleFavorite,
  dashboardInstanceResetLastVisited,
  dashboardInstanceUpdateReportInfo,
  dashboardInstanceReset,
  reloadDashboardTemplates,

  dashboardCustomizationActivate,
  dashboardCustomizationReset,
  dashboardCustomizationSetFilter,
  dashboardCustomizationExpandNamedFilter,
  dashboardCustomizationSetDateRange,
  populatePublishedFolder,
  renameSubFolder,
  deleteSubFolder,
} = slice.actions;
export default slice.reducer;
